import type { CustomRuleManagedBy } from '@/lib/custom-rules/schema';

import { CUSTOM_RULE_SOURCE_VALUES } from '@/lib/custom-rules/schema';

// Only expose type information here so client bundles stay tree-shakeable and do not pull in
// Prisma's runtime. Server code that needs the enum value itself should import from
// `./sources.server.ts`, which re-exports it safely for Node-only usage.

export type CustomRuleSource = CustomRuleManagedBy;

const [UI_SOURCE, YAML_SOURCE] = CUSTOM_RULE_SOURCE_VALUES;

export const CUSTOM_RULE_SOURCE = {
  UI: UI_SOURCE,
  YAML: YAML_SOURCE,
} as const satisfies Record<'UI' | 'YAML', CustomRuleSource>;

export const YAML_CUSTOM_RULE_SOURCE = CUSTOM_RULE_SOURCE.YAML;
export const UI_CUSTOM_RULE_SOURCE = CUSTOM_RULE_SOURCE.UI;
